<main>
  <loading-overlay [isLoading]="isLoading"></loading-overlay>

  <div class="content">
    <div class="grid grid-cols-12">
      <div class="col-span-12 md:col-span-4">
        <div class="brand__wrapper">
          <div class="app-icon"></div>
          Sierra ASC
        </div>
        <h1>Login</h1>
        <form [formGroup]="loginFormGroup" (ngSubmit)="login()">
          <div class="flow">
            <div class="form-box">
              <label>User Name</label>
              <input pInputText class="w-full" type="email" id="userNameLogin" formControlName="username" />
            </div>
            <label for="">Password</label>
            <p-password fluid id="passwordLogin" formControlName="password" [toggleMask]="true" [feedback]="false" />
            <div class="flex mt-[2rem] mb-[1rem]">
              <p-button label="Login" type="submit" />
              <p class="error" *ngIf="!isLoading && wrongCredentials">Sorry, login information provided is incorrect.</p>
            </div>
            <label class="info__label">If you have forgotten your username or password please contact info&#64;card-software.com</label>
          </div>
        </form>
      </div>
    </div>
  </div>
</main>
